const isUSA = (country) => country === "United States of America";

const shouldShowStateAsInput = (country, stateOptions) => {
  return country !== "United States of America" && (!stateOptions || stateOptions.length === 0);
};

export const getCompanyFields = (
  countryStateList,
  companyStateOptions,
  phibroRepOptions,
  selectedCompanyLocations,
  editMode,
  companyForm
) => {
  const selectedCountry = companyForm?.country;
  return [
    {
      name: "companyName",
      label: "Company Name",
      type: "text",
      placeholder: "Enter Company Name",
      validations: ["required"],
    },
    {
      name: "country",
      label: "Country",
      type: "select",
      options: countryStateList.map((c) => ({
        label: c.country,
        value: c.country,
      })),
      validations: ["required"],
    },
    {
      name: "state",
      label: "State",
      type: shouldShowStateAsInput(selectedCountry, companyStateOptions) ? "text" : "select",
      options: shouldShowStateAsInput(selectedCountry, companyStateOptions)
        ? []
        : companyStateOptions.map((state) => ({
            label: state,
            value: state,
          })),
      validations: ["required"],
      disabled: !selectedCountry,
    },
    {
      name: "city",
      label: "City",
      type: "text",
      placeholder: "Enter City",
      validations: ["required"],
    },
  ];
};

export const getLocationFields = (
  companyList,
  locationStateOptions,
  countryStateList,
  phibroRepOptions,
  selectedCompanyLocations,
  editMode,
  locationForm
) => {
  const selectedCountry = locationForm?.country;
  return [
    {
      name: editMode === "location" ? "companyName" : "companyId",
      label: "Company Name",
      type: editMode === "location" ? "text" : "select",
      placeholder: "Select Company",
      searchable: true,
      searchPlaceholder: "Search Company",
      options: companyList.map((company) => ({
        label: company.name,
        value: company.companyId,
      })),
      validations: ["required"],
      disabled: editMode === "location",
    },
    {
      name: "location",
      label: "Location",
      type: "text",
      placeholder: "Enter Location",
      validations: ["required"],
    },
    {
      name: "address",
      label: "Address",
      type: "text",
      placeholder: "Enter Address",
      validations: ["required"],
    },
    {
      name: "country",
      label: "Country",
      type: "select",
      options: countryStateList.map((c) => ({
        label: c.country,
        value: c.country,
      })),
      validations: ["required"],
    },
    {
      name: "state",
      label: "State",
      type: shouldShowStateAsInput(selectedCountry, locationStateOptions) ? "text" : "select",
      options: shouldShowStateAsInput(selectedCountry, locationStateOptions)
        ? []
        : locationStateOptions.map((state) => ({
            label: state,
            value: state,
          })),
      validations: ["required"],
      disabled: !selectedCountry,
    },
    {
      name: "city",
      label: "City",
      type: "text",
      placeholder: "Enter City",
      validations: ["required"],
    },
    {
      name: "zip",
      label: "Zip",
      type: "text",
      placeholder: "Enter Zip Code",
      validations: isUSA(selectedCountry) ? ["required"] : [],
      options: undefined,
      disabled: false,
    },
    {
      name: "phone",
      label: "Phone",
      type: "text",
      placeholder: "Enter Phone Number",
      validations: ["required"],
    },

    {
      name: "fieldStaffId",
      label: "Phibro Sales Rep",
      type: "select",
      validations: ["required"],
      options: phibroRepOptions.filter(Boolean).map((rep) => ({
        label: rep.fullName,
        value: rep.userID,
      })),
    },
  ];
};
